import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CloseProjectStaffWidget from '../../../widgets/closeProject/CloseProjectStaffWidget'
import CloseProjectWidget from '../../../widgets/closeProject/CloseProjectWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { getCloseOfProjectStaffForm } from '../../../redux/actions/closeOfProject'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getWithdrawRequestStatus } from '../../../redux/actions/withdrawRequest'
import WithdrawRequestStatusWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import { Message } from 'rsuite'
import { downloadProgressFile } from '../../../redux/actions/projectProgress'
import { getProjectEvaluation } from '../../../redux/actions/projectEvaluation'
import CoworkerEvaluateThaihealthWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateThaihealthWidgets/CoworkerEvaluateThaihealthWidget'
import ConfirmActualResultWidget from '../../../widgets/confirmActualResultWidget/ConfirmActualResultWidget'
import { getAssessmentForm } from '../../../redux/actions/assessment'
import EvaluationFormWidget from '../../../widgets/evaluationForm/EvaluationFormWidget'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'

export default function CloseOfProjectStaff(props) {
  //ปิดโครงการ นักวิชาการ
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()
  const [schema, setSchema] = useState()
  const projectsProgressId = '99'
  const [evaluationId, setEvaluationId] = useState()

  const projectId = sessionStorage.getItem('projectId')

  const [assessmentSchema, setAssessmentSchema] = useState()
  const [assessmentError, setAssessmentError] = useState()
  const [isDraftAssessment, setIsDraftAssessment] = useState(true)

  useEffect(() => {
    console.log('CloseOfProject ', projectId)
    if (projectId === 'mock-wait-approve') {
      setSchemas(mockSchema.model)
      setWithdrawRequestStatusSchema(mockWithdrawRequestStatus)
    } else {
      handleGetSchema(projectId)
      handleGetAssessmentSchema(projectId)
    }
    //projectId && handleGetDownloadProgressFile(projectId)
    //handleGetEvaluationSchema(projectId, projectsProgressId)
  }, [projectId])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getCloseOfProjectStaffForm(projectId)
      // console.log('_schema_schema_schema', _schema)
      // const _schema = x
      if (_schema.success) {
        if (
          _schema?.model?.forms?.requestNoteStaff?.sendToGrantee &&
          _schema?.model?.forms?.requestNoteStaff?.noteSendToGrantee?.value
        ) {
          _schema.model.forms.agreementDetails = {
            title: 'รายละเอียดสำหรับแก้ไข',
            content: _schema?.model?.forms?.requestNoteStaff?.noteSendToGrantee?.value || '',
            datetime: null,
            status: null,
          }
        }

        setSchemas(_schema.model)
      }

      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadProgressFile = async (projectId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const progressId = schemas.forms.projectProgressId || ''
      const response = await downloadProgressFile(projectId, progressId)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.log('error ', e)
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  // const handleGetEvaluationSchema = async (projectId, projectsProgressId, evaluationId) => {
  //   try {
  //     const response = await getProjectEvaluation(projectId, projectsProgressId, evaluationId)
  //     setSchema(response.forms)
  //     setEvaluationId(response.forms?.evaluationId)
  //     // console.log('response==>', response)
  //     // setSchema(mockSchema2.form)
  //   } catch (e) {
  //     console.log('error', e)
  //     if (e?.response?.data) {
  //       setError({
  //         statusCode: e.response.data.status,
  //         errorMessage: e.response.data.errors?.message,
  //       })
  //     } else {
  //       setError({})
  //     }
  //   }
  // }

  const handleGetAssessmentSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentForm(null, null, projectId, 99, 2, null, 2)
      if (response) {
        setAssessmentSchema(response)
        setIsDraftAssessment(response.isDraft)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setAssessmentError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        })
      } else {
        setAssessmentError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />
        {schemas?.forms?.agreementDetails && (
          <>
            <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
          </>
        )}
        {withdrawRequestStatusSchema?.forms?.withdrawRequestStatus && (
          <>
            <WithdrawRequestStatusWidget
              showCommandButton={true}
              schema={withdrawRequestStatusSchema.forms.withdrawRequestStatus}
              header={'ประวัติการเบิกจ่ายเงินงวด'}
              isCloseProject={true}
            />
            <br />
          </>
        )}
        {/* ตรงขอปิดนักวิชาการ การประเมิน */}
        {assessmentError ? (
          <>
            <Panel shaded collapsible defaultExpanded header={'แบบประเมิน'} bordered>
              <Message
                showIcon
                type="error"
                description={`${assessmentError.statusCode} ${assessmentError.errorMessage}`}
              />
            </Panel>
            <br />
          </>
        ) : (
          assessmentSchema?.assessmentCategoryForm &&
          assessmentSchema?.assessmentCategoryForm.length > 0 && (
            <>
              <EvaluationFormWidget
                schema={assessmentSchema}
                isPanel={true}
                isDraftAssessment={isDraftAssessment}
                setIsDraftAssessment={setIsDraftAssessment}
                assessmentFor={2}
                disabled={schemas?.forms?.requestNoteStaff?.disabled}
              />
            </>
          )
        )}
        {/* {schemas?.forms?.requestNoteStaff && (
          <>
            <CoworkerEvaluateThaihealthWidget
              schema={schema}
              disabled={schemas?.forms?.requestNoteStaff?.disabled}
              evaluationId={() => setEvaluationId(true)}
            />
          </>
        )} */}

        {/* ยืนยันผลการดำเนินการจริง */}
        {schemas?.forms?.confirmActualResul && (
          <>
            <ConfirmActualResultWidget
              schema={schemas?.forms?.confirmActualResul}
              checked={schemas?.forms?.confirmActualResulChecked}
              numberOfInstallment={schemas?.forms?.confirmActualResul?.numberOfInstallment || 0}
              // isViewMode={true}
            />
          </>
        )}

        {schemas?.forms?.requestNoteStaff && schemas?.forms?.projectEvaluation && (
          <>
            <CloseProjectStaffWidget
              showCommandButton={!schemas?.forms?.requestNoteStaff?.disabled}
              schema={schemas?.forms?.requestNoteStaff}
              // schema={xsss}
              schemaEvaluate={schemas?.forms?.projectEvaluation}
              evaluateDisabled={schemas?.forms?.projectEvaluation.disabled}
              evaluationId={!evaluationId}
              isDraftAssessment={isDraftAssessment}
              onSuccess={() => handleGetSchema(projectId)}
              // isDraftAssessment={isDraftAssessment}
            />
            <br />
          </>
        )}

        {schemas?.forms?.requestNote && (
          <>
            <CloseProjectWidget
              showCommandButton={!schemas?.forms?.requestNote?.disabled}
              schema={schemas?.forms?.requestNote}
              evaluationId={() => setEvaluationId(true)}
            />
            <br />
          </>
        )}

        {isPdfError ? (
          <>
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            <br />
          </>
        ) : (
          <>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              header={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              fileName={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              onReload={() => handleGetDownloadProgressFile(projectId)}
              loadingMessage={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              firstExpandToReload={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
